<template>
    <div class="home">
        <header>
            <img class="head-img center-y" :src="avatar" alt="" srcset="">
            <img v-show="isDJ" class="dj-logo" src="../assets/img/dj.png?v=20201104" alt="" srcset="">
            <div class="info">
                <span class="name">{{authorName}}</span>
                <span class="edit" @click="editInfo()">编辑资料 ></span>
                <p class="tags" v-show="isDJ">
                    <span>remix</span>
                </p>
                <p v-show="!isDJ" style="margin-top:12px;color:#888888">欢迎选择酷狗音乐人平台，距离成为酷狗音乐人还有最后一步哦</p>
            </div>
            <img class="center-y logo" src="../assets/img/kugou_musician.png" alt="" srcset="" />
        </header>
        <div class="charts-c" v-show="isDJ" >
            <div>
                <p class="title">收藏趋势</p>
                <p class="data">
                    <span class="num">{{todayCollect}}</span>
                    <span>昨日收藏<br>日新增
                    <img v-if="collectChange > 0" src="../assets/img/up.png" alt="">
                    <img v-if="collectChange < 0" src="../assets/img/down.png" alt="">
                    {{collectChange}}</span>
                </p>
                <div class="chart-title">酷狗音乐</div>
                <Echarts v-show="playsData.xAxisData && playsData.xAxisData.length != 0" width="100%" height="240px" label="收藏量" :data="playsData" id="plays_charts"></Echarts>
                <div v-show="playsData.xAxisData && playsData.xAxisData.length == 0" style="margin-top: 90px;text-align:center">数据24小时后显示</div>
            </div>
            <div>
                <p class="title">粉丝趋势</p>
                <p class="data">
                    <span class="num">{{todayFans}}</span>
                    <span>昨日粉丝<br>日新增
                    <img v-if="fansChange > 0" src="../assets/img/up.png" alt="">
                    <img v-if="fansChange < 0" src="../assets/img/down.png" alt="">
                    {{fansChange}}</span>
                </p>
                <div class="chart-title">酷狗音乐</div>
                <Echarts v-show="fansData.xAxisData && fansData.xAxisData.length != 0" width="100%" height="240px" label="粉丝数" :data="fansData" id="fans_charts"></Echarts>
                <div v-show="fansData.xAxisData && fansData.xAxisData.length == 0" style="margin-top: 90px;text-align:center">数据24小时后显示</div>
            </div>
        </div>
        <div class="cow" v-show="isDJ" >
            <div class="work-data">
                <div class="title">作品管理</div>
                <ul>
                    <li v-for="(item, i) in work_data" :key="i" @click="gotoWork">
                        <span class="num">{{item.value}}</span><br>
                        <span class="label">{{item.label}}</span>
                    </li>
                </ul>
            </div>
            <div class="right">
                <div class="title">可兑换特权</div>
                <div class="beans-c">
                    当前酷豆：
                    <span class="beans">{{beans}}</span>
                    <span style="color:#0090ff;margin-left:15px;text-decoration:underline;cursor:pointer" @click="gotoTask">获得酷豆</span>
                    <span style="color:#0090ff;margin-left:15px;text-decoration:underline;cursor:pointer" @click="gotoChange">更多特权</span>
                </div>
                <div class="right-list">
                    <img v-for="(item, i) in right_list" :key="i" :src="item" alt=""  @click="gotoTask"/>
                </div>
            </div>
        </div>
        <div class="add-tip" v-show="!isDJ">
            <div class="status-c">
                <p v-show="audit_status == 4">你已提交作品，请耐心等待审核。审核通过后，将开放以下权益</p>
                <p v-show="audit_status == 5">以下歌曲审核未通过：</p>
                <div class="fail-content"  v-show="audit_status == 5">
                    <p class="hl" v-for="(item, i) in failed_content" :key="i">《{{item.song_name}}》-{{item.review_message}}</p>
                </div>
                <p v-show="audit_status == 1" style="font-size:24px">上传作品并上架成功，立即获得酷狗音乐人身份，还能解锁5大音乐人特权</p>
                <div v-show="audit_status == 1" class="add" @click="gotoAdd">发布作品</div>
                <div v-show="audit_status == 5" class="add"  @click="gotoWork">去修改</div>
            </div>
            
            <ul class="right-c">
                <li v-for="(item, i) in rightArr" :key="i">
                    <img :src="item.img" alt="">
                    <p class="title">{{item.title}}</p>
                    <p class="desc">{{item.desc}}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import md5 from 'md5'
export default {
    mounted() {
        this.$nextTick(() => {
            this.myStatus(() => {
                this.getMusicianData()
                //this.getMusicianFans()
                //this.getWorkData()
                this.getTotalFans()
                this.getBeans()
            })
        })
    },
    methods: {
        editInfo() {
            this.$router.push('/edituser')
            // if(!this.info.review_status) {
            // }else if(this.info.review_status == 1) {
            //     window.eventEmitter.emit('toast', '您的歌手资料更改审核中')
            // } else {
            //     this.$router.push('/edituser')
            // }
        },
        gotoTask() {
            window.parent.location.hash = '#/user/manage/tasks';
            window.parent.location.reload();
        },
        gotoChange() {
            window.parent.location.hash = '#/user/manage/change';
            window.parent.location.reload();
        },
        gotoWork() {
            this.$router.push('/work')
        },
        gotoAdd() {
            this.$router.push('/editsong')
        },
        //获取我的状态
        myStatus(cb) {
            this.api({
                apiName: 'myStatus',
                methods: 'GET',
                getData: {
                    biz: 'musician_author_dj'
                }
            }).then(res => {
                const data = res.data
                this.audit_status = data.audit_status
                this.info = data.info
                //未提交实名信息
                if(data.audit_status == 0 && data.is_settle == 0) {
                    this.$router.push('/enter')
                } else {
                    const info = data.info
                    this.total_content = data.total_content
                    this.authorName = info.author_name
                    this.failed_content = data.failed_content
                    this.avatar = this.replaceHttpsImg(info.avatar)
                    this.work_data[0].value = res.data.total_content
                     //通过
                    if(data.is_settle) {
                        this.isDJ = true
                        this.singerid = info.author && info.author.author_id || 0
                        cb && typeof cb === 'function' && cb()
                    } else if(data.audit_status == 3 || data.audit_status == 2) {
                        //不通过或审核中
                        this.$router.push('/status')
                    } else {
                        //留在home
                        
                    }
                }
            }).catch(err => {
                window.eventEmitter.emit('toast', err.error || "服务器异常")
                this.$router.push('/enter')
            })
        },
        //酷豆余额
        getBeans() {
            this.api({
                apiName: 'beans',
                methods: 'GET',
                getData: {}
            }).then(res => {
                this.beans = res.data.bean_balance
            }) 
        },
        //主页作品管理歌曲数
        getWorkData() {
            const time = new Date().getTime()
            this.api({
                apiName: 'musicianWorkData',
                methods: 'GET',
                getData: {
                    'appid': window.appid,
                    'clienttime': time,
                    'token': window.token,
                    'clienttype': 2,
                    'clientver': 1000,
                    'user_id': window.kugouid,
                    'key': md5(1014 + 'iYw1iw8z2ji2iphcu80oOo2ki8112p' + 1000 + time),
                    'singer_id': this.singerid,
                    'newver': 1
                }
            }).then(res => {
                this.work_data[0].value = res.data.num
            }) 
        },
        //主页热度趋势
        getMusicianData() {
            const time = new Date().getTime()
            this.api({
                apiName: 'musicianData',
                methods: 'GET',
                getData: {
                    'appid': window.appid,
                    'clienttime': time,
                    'token': window.token,
                    'clientver': 1000,
                    'singer_id': this.singerid,
                }
            }).then(res => {
                if(res.data.length != 0) {
                    console.log(res.data);
                    const tempArr = res.data.items.slice(0, 30).reverse()

                    this.collectChange = tempArr[tempArr.length-1].collection - tempArr[tempArr.length-2].collection;
                    this.todayCollect = tempArr[tempArr.length-1].collection
                    this.playsData = {
                        xAxisData : tempArr.map(item => item.date.split(' ')[0].slice(5)),
                        seriesData : tempArr.map(item => item.collection)
                    }

                    this.fansChange = tempArr[tempArr.length-1].fan - tempArr[tempArr.length-2].fan;
                    this.fansData = {
                        xAxisData : tempArr.map(item => item.date.slice(5)),
                        seriesData : tempArr.map(item => item.fan)
                    }
                    console.log('this.playsData',this.playsData)
                } else {
                    this.collectChange = 0
                    this.todayCollect = 0
                }
            }) 
        },
        ////主页粉丝趋势，getMusicianData里面的fan数据不准，要用另外接口
        getMusicianFans() {
            this.api({
                apiName: 'musicianFans',
                getData: {
                    kugouid: window.kugouid
                },
                postData: {
                    typ: 1,
                    start_time: (new Date().getTime() - 30*24*60*60*1000) / 1000,
                    end_time: (new Date().getTime() - 1*24*60*60*1000) / 1000
                }
            }).then(res => {
                const tempArr = res.data;
                //this.todayFans = tempArr[tempArr.length-1].fans_trend.total_fans_num
                this.fansChange = tempArr[tempArr.length-1].fans_trend.added_fans_num
                this.fansData = {
                    xAxisData : tempArr.map(item => item.add_date.slice(5)),
                    seriesData : tempArr.map(item => item.fans_trend.added_fans_num)
                }
            }) 
        },
        //粉丝总数
        getTotalFans() {
            this.api({
                apiName: 'getTotalFans',
                postData: {
                    userid: window.kugouid,
                    singerids: [this.singerid],
                    token: window.token
                }
            }).then(res => {
                this.todayFans = res.data.fansnums[0].num >= 0 ? res.data.fansnums[0].num : 0
            })
        }
    },
    data() {
        return {
            info: {},
            beans: 0,
            audit_status: 0,
            failed_content: [],
            total_content: 0,
            rightArr: [{
                img: require('../assets/img/right1.png'),
                title: '一键发布酷狗平台',
                desc: '作品可自助发布到酷狗音乐'
            },{
                img: require('../assets/img/right2.png'),
                title: '播放量扶持',
                desc: '做任务得酷豆可兑换推广量'
            },{
                img: require('../assets/img/right3.png'),
                title: '粉丝推送',
                desc: '新歌上线可推送给你的粉丝'
            },{
                img: require('../assets/img/right4.png'),
                title: '数据中心',
                desc: '便捷查看作品数据，更好运营自己'
            },{
                img: require('../assets/img/right5.png'),
                title: '一站式管理',
                desc: '上传/修改歌曲，酷狗平台同步更新'
            }],
            isDJ: false,
            authorName: '',
            avatar: '' || require('../assets/img/default.png'),
            singerid: 0,
            collectChange: 0,
            fansChange: 0,
            todayCollect: 0,
            todayFans: 0,
            right_list: [
                require('../assets/img/right_1.png'),
                require('../assets/img/right_2.png'),
                require('../assets/img/right_3.png')
            ],
            work_data: [{
                id: 0,
                label: 'Remix作品',
                value: 0
            }],
            playsData: {
                // xAxisData: ["11.26","11.27","11.28","11.29","11.30","12.01","12.02"],
                // seriesData: [0,100,300,400,550,1002,1200]
                xAxisData: [],
                seriesData: []
            },
            fansData: {
                // xAxisData: ["11.26","11.27","11.28","11.29","11.30","12.01","12.02"],
                // seriesData: [1,2,3,4,5,6,7]
                xAxisData: [],
                seriesData: []
            }
        }
    },
}
</script>

<style lang="scss" scoped>
    .home {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        position: relative;
        header {
            width: 100%;
            height: 150px;
            border-radius: 10px;
            position: relative;
            background: #fff;
            .logo {
                right: 25px;
            }
            .head-img {
                left: 30px;
                width: 90px;
                height: 90px;
                border-radius: 50%;
            }
            .dj-logo {
                width: 20px;
                height: 20px;
                position: absolute;
                top: 100px;
                left: 100px;
            }
            .info {
                position: absolute;
                top: 40px;
                left: 140px;
                .name {
                    font-size: 28px;
                    color: #333;
                }
                .edit {
                    color: #0090ff;
                    font-size: 16px;
                    margin-left: 10px;
                    text-decoration: underline;
                    cursor: pointer;
                }
                .tags {
                    margin-top: 15px;
                    > span {
                        display: inline-block;
                        height: 24px;
                        line-height: 24px;
                        border-radius: 13px;
                        padding: 0 15px;
                        font-size: 14px;
                        color: #0090ff;
                        border: 1px #0090ff solid;
                    }
                }
            }
        }
        .charts-c {
            width: 100%;
            height: 360px;
            display: flex;
            margin-top: 10px;
            > div {
                flex: 1;
                background: #fff;
                border-radius: 10px;
                padding: 24px 32px;
                position: relative;
                .title {
                    color: #000000;
                    font-size: 18px;
                }
                .data {
                    margin-top: 20px;
                    font-size: 14px;
                    > span {
                        display: inline-block;
                    }
                    .num {
                        color: #333;
                        font-size: 40px;
                        padding-right: 15px;
                        margin-right: 10px;
                        position: relative;
                        &::after {
                            content: '';
                            position: absolute;
                            width: 1px;
                            height: 30px;
                            background-color: rgba(0,0,0,0.1);
                            right: 0;
                            top: 50%;
                            margin-top: -15px;
                        }
                    }
                }
                .chart-title {
                    font-size: 14px;
                    color: #888888;
                    position: absolute;
                    right: 100px;
                    top: 90px;
                    padding-left: 15px;
                    &::before {
                        content: '';
                        position: absolute;
                        width: 5px;
                        height: 5px;
                        border-radius: 50%;
                        background-color: #0090ff;
                        left: 0;
                        top: 50%;
                        margin-top: -2px;
                    }
                }
                &:first-child {
                    margin-right: 10px;
                }
            }
        }
        .cow {
            width: 100%;
            height: 180px;
            display: flex;
            margin-top: 10px;
            > div {
                flex: 1;
                background: #fff;
                border-radius: 10px;
                padding: 24px 32px;
                position: relative;
                .title {
                    color: #000000;
                    font-size: 18px;
                }
                &:first-child {
                    margin-right: 10px;
                }
            }
            .work-data {
                overflow: hidden;
                ul {
                    margin-top: 30px;
                    li {
                        cursor: pointer;
                        float: left;
                        width: 22%;
                        height: 80px;
                        margin-right: 3%;
                        position: relative;
                        &::after {
                            content: '';
                            position: absolute;
                            width: 1px;
                            height: 50px;
                            background-color: rgba(0,0,0,0.1);
                            right: 0;
                            top: 50%;
                            margin-top: -25px;
                        }
                        &:last-child {
                            margin-right: 0;
                            &::after {
                                content: none;
                            }
                        }
                        .num {
                            font-size: 40px;
                            color: #333;
                        }
                        .label {
                            font-size: 14px;
                            color: #888888;
                        }
                    }
                }
            }
            .right {
                .beans-c {
                    position: absolute;
                    top: 27px;
                    left: 130px;
                    font-size: 14px;
                    color: #888;
                    padding-left: 10px;
                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 5px;
                        width: 2px;
                        height: 10px;
                        background-color: #888;
                    }
                }
                .right-list {
                    margin-top: 30px;
                    height: 83px;
                    overflow: hidden;
                    img {
                        margin-right: 10px;
                        width: 30%;
                        max-width: 183px;
                        cursor: pointer;
                    }
                }
            }
        }
        .add-tip {
            height: calc(100vh - 225px);
            border-radius: 10px;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 5px;
            padding-bottom: 50px;
            .status-c {
                padding: 60px 0;
                display: flex;
                flex-direction: column;
                align-items: center;
                border-bottom: 1px solid #eff0f5;
                .add {
                    width: 180px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    border-radius: 20px;
                    color: #fff;
                    font-size: 18px;
                    background-color: #0090ff;
                    margin-top: 35px;
                    cursor: pointer;
                }
                .fail-content {
                    p {
                        margin-top: 10px;
                    }
                    .hl {
                        color: red;
                    }
                }
            }
            .right-c {
                width: 80%;
                margin: 0 auto;
                display: flex;
                flex-wrap: wrap;
                > li {
                    width: 33%;
                    position: relative;
                    margin-top: 30px;
                    img {
                        width: 55px;
                        height: 55px;
                    }
                    .title {
                        position: absolute;
                        top: 5px;
                        left: 70px;
                        font-size: 18px;
                    }
                    .desc {
                        position: absolute;
                        top: 30px;
                        left: 70px;
                        font-size: 14px;
                        color: #888;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/view/Home.vue